import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  BreadcrumbModule,
  EmptyStateModule,
  ModalModule,
  PaginatorModule,
  TableModule,
  StatusModule,
  IconModule,
  ThemingModule,
  ScrollbarModule,
  DropdownModule,
  AlertModule
} from '@michelin/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '../../shared/shared.module';
import { SearchCasingsComponent } from './components/search-casings/search-casings.component';
import { CasingSearchResultComponent } from './components/casing-search-result/casing-search-result.component';
import { TransferCasingExistingWorkorderComponent } from './components/transfer-casing-existing-workorder/transfer-casing-existing-workorder.component';
import { CustomerSelectModelComponent } from '../../shared/components/customer-select-model/customer-select-model.component';
import { MichelinDropdownAccessibilityDirective } from '../../shared/directives/michelin-dropdown-accessibility.directive';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [SearchCasingsComponent, CasingSearchResultComponent, TransferCasingExistingWorkorderComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BreadcrumbModule,
    EmptyStateModule,
    ModalModule,
    PaginatorModule,
    TableModule,
    StatusModule,
    IconModule,
    ThemingModule,
    ScrollbarModule,
    DropdownModule,
    MichelinDropdownAccessibilityDirective,
    AlertModule,
    MatDialogModule,
    MatCheckboxModule,
    MatDividerModule,
    MatChipsModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    DragDropModule,
    CustomerSelectModelComponent
  ],
  exports: [SearchCasingsComponent, CasingSearchResultComponent, TransferCasingExistingWorkorderComponent]
})
export class SearchModule {}
